import React, { forwardRef } from 'react';

import classes from './CustomInput.module.css';

type IProps = React.InputHTMLAttributes<HTMLInputElement> & {
    label?: string;
};

const CustomInput = forwardRef<HTMLInputElement, IProps>(
    ({ label, className = '', ...rest }, ref) => {
        return (
            <>
                {label && <label className={classes.label}>{label}</label>}
                <input
                    {...rest}
                    ref={ref}
                    className={`${classes['custom-input']} ${className}`.trim()}
                />
            </>
        );
    },
);
export default React.memo(CustomInput);
